import hoverCardEffect from "@assets/images/about-us/card-bg.jpg";
import { trans } from "@mongez/localization";

export type MemberCardProps = {
  member: {
    name: string;
    position: string;
    description: string;
    image?: string;
  };
};

export function MemberCard({ member }: MemberCardProps) {
  return (
    <div className="group relative rounded-3xl shadow-leadership-card transition-all duration-500 ease-in-out hover:shadow-lg sm:rounded-[35px] md:rounded-[40px]">
      {/* Hover border - appears with transition */}
      <div className="absolute inset-0 z-0 rounded-3xl bg-card-border opacity-0 transition-opacity duration-500 ease-in-out group-hover:opacity-100 sm:rounded-[35px] md:rounded-[40px]"></div>

      {/* Content */}
      <div className="relative z-20 m-[1px] h-[calc(100%_-_2px)] w-[calc(100%_-_2px)] rounded-[calc(1.5rem-1px)] bg-white p-4 sm:rounded-[calc(35px-1px)] sm:p-5 md:rounded-[39px] md:p-6">
        <img
          src={hoverCardEffect}
          alt="Hover Effect Background"
          className="absolute inset-0 z-10 h-full w-full rounded-3xl object-cover opacity-0 transition-opacity duration-500 ease-in-out group-hover:opacity-100 sm:rounded-[35px] md:rounded-[40px]"
        />
        <div className="relative z-20 flex flex-col gap-3 max-lg:items-center sm:flex-row sm:gap-4">
          {/* Image with gradient border */}
          <div className="min-size-24 relative mx-auto max-h-fit flex-shrink-0 rounded-2xl sm:mx-0 sm:rounded-[25px] md:rounded-[31px]">
            {/* Default image border - always visible */}
            <div className="absolute inset-0 rounded-2xl bg-image-border-default sm:rounded-[25px] md:rounded-[31px]" />

            {/* Hover image border - appears with transition */}
            <div className="absolute inset-0 rounded-[calc(1rem-1px)] bg-image-border-hover opacity-0 transition-opacity duration-500 ease-in-out group-hover:opacity-100 sm:rounded-[24px] md:rounded-[30px]" />

            {/* Image content */}
            <div className="relative m-[1px] rounded-[calc(1rem-1px)] bg-white sm:rounded-[24px] md:rounded-[30px]">
              {member.image ? (
                <img
                  src={member.image}
                  alt={member.name}
                  className="h-24 w-24 rounded-[calc(1rem-1px)] bg-gray-300 sm:h-32 sm:w-32 sm:rounded-[24px] md:h-[154px] md:w-[160px] md:rounded-[30px]"
                />
              ) : (
                <div className="rounded-[calc(1rem-1px)] bg-gray-300 sm:h-32 sm:w-32 sm:rounded-[24px] md:h-[154px] md:w-[160px] md:rounded-[30px]" />
              )}
            </div>
          </div>
          <div className="min-w-0 flex-1 text-center sm:text-left rtl:sm:text-right">
            <h3 className="mb-1 text-lg font-semibold text-black transition-colors duration-500 ease-in-out group-hover:text-bright-orange sm:mb-1 sm:text-xl md:mb-1 md:text-xl">
              {trans(member.name)}
            </h3>
            <p className="mb-2 text-xs sm:text-sm font-semibold leading-relaxed text-[#7A7986] transition-colors duration-500 ease-in-out group-hover:text-marine md:text-base sm:leading-8 xl:text-xl xl:leading-[32px]">
              {trans(member.position)}
            </p>
            {member.description && (
              <p className="text-sm leading-relaxed text-[#7A7986] sm:text-base md:text-lg">
                {trans(member.description)}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
